import React from 'react'
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';



export const GenericInput = ({
    register,
    name,
    placeholder,
    maxLength,
    tooltip,
    errors,
    setValue,
    className = "",
    type = "text",
    required = false,
    pattern,
    minLength,
    isErrorFetching,
    message,
    validate,
    handleAutoCompleteAddress,
    // ...props,
}) => {

    return (
        <IconField className="Input">
            <InputText
                maxLength={maxLength || 50}
                type={type}
                placeholder={placeholder}
                className={`Input w-full TextInput ${errors?.[name] ? 'TextInputError' : ''}`}
                tooltip={errors?.[name]?.message}
                tooltipOptions={{ position: 'top' }}
                {...register(name, {
                    pattern: pattern && {
                        value: pattern,
                        message: 'Formato inválido'
                    },
                    required: required && {
                        value: true,
                        message: 'ESTE CAMPO ES REQUERIDO'
                    },
                    minLength: minLength && {
                        value: minLength,
                        message: `Mínimo ${minLength} caracteres`
                    },
                    validate: validate,
                    onChange: (e) => {
                        // if(name === 'rfc'){
                        //     rfcRef.current = e.target.value
                        // }
                        setValue(name, e.target.value, { shouldValidate: true });
                        if (name === 'zip' && handleAutoCompleteAddress) {
                            handleAutoCompleteAddress(e.target.value)
                        }
                    }// Usar la función de validación personalizada
                })}

                // {...props}
            />
            {errors?.[name] && (
                <small className="p-error" style={{ display: 'block', marginTop: '0.25rem' }}>
                    {errors[name].message}
                </small>
            )}
            {isErrorFetching && message && (
                <small className="p-error" style={{ display: 'block', marginTop: '0.25rem' }}>
                    {message}
                </small>
            )}
        </IconField>
    );
};
